import React, { Component } from "react";
import { toast, ToastContainer } from "react-toastify";

import {
  getCookieData,
  getPermissionStatus,
} from "../../../utils/CommonFunction";
import { petrolRequestModuleData } from "../../../utils/apiRoutes";
import { getHeaders } from "../../../utils/apiHelper";
import LoadingIndicator from "../../Common/components/LoadingIndicator";
import PageHeader from "../../layouts/PageHeader";
import PetrolForm from "./petrol_form/PetrolForm";
import PetrolRequests from "./petrol_requests/PetrolRequests";
import PetrolView from "./petrol_requests/PetrolView";

export default class Petrol extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      amountPerKmCar: 0,
      amountPerKmBike: 0,
      petrolVehicleTypes: [],
      withdrawalLocations: [],
      petrolTripTypes: [],
      employees: [],
      regions: [],
      departments: [],
      positions: [],
      user_info: getCookieData("user_info"),
      isAddNew: false,
      isRequestsList: true,
      isView: false,
      isEdit: false,
      petrolApplicationData: [],
      permission_status: {},
    };
  }

  async componentDidMount() {
    const responseData = await this.getModuleData();
    const permissionStatus = await this.fetchPermissionStatus();
    if (!!responseData) {
      this.initModuleData(responseData.data, permissionStatus);
    }
  }

  getModuleData = async () => {
    const res = await fetch(petrolRequestModuleData, {
      headers: getHeaders(),
    });
    if (res.ok) {
      return res.json();
    } else {
      this.setState({
        isLoading: false,
      });
      this.showError("Something went wrong... Couldn't load data!");
      return null;
    }
  };

  fetchPermissionStatus = async () => {
    return await getPermissionStatus(
      this.state.user_info.designations_id,
      "Petrol Request",
      "Allowance"
    );
  };

  initModuleData = async (moduleData, permissionStatus) => {
    this.setState({
      amountPerKmCar: moduleData.amountPerKmCar,
      amountPerKmBike: moduleData.amountPerKmBike,
      petrolVehicleTypes: moduleData.petrolVehicleTypes,
      withdrawalLocations: moduleData.withdrawalLocations,
      petrolTripTypes: moduleData.petrolTripTypes,
      employees: moduleData.employees,
      regions: moduleData.regions,
      departments: moduleData.departments,
      positions: moduleData.positions,
      isLoading: false,
      permission_status: permissionStatus,
    });
  };

  resetStateObj = {
    isAddNew: false,
    isRequestsList: false,
    isView: false,
    isEdit: false,
  };

  handleClickAddNew = () => {
    this.setState({
      ...this.resetStateObj,
      isAddNew: true,
    });
  };

  handleClickView = (data) => {
    this.setState({
      ...this.resetStateObj,
      petrolApplicationData: data,
      isView: true,
    });
  };

  handleClickEdit = async (data) => {
    this.setState({
      ...this.resetStateObj,
      petrolApplicationData: data,
      isEdit: true,
    });
  };

  goBack = () => {
    this.setState({
      ...this.resetStateObj,
      isRequestsList: true,
    });
    window.location.reload();
  };

  showError = (message) => {
    toast.error(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  };

  render() {
    if (this.state.isLoading) return <LoadingIndicator />;

    return (
      <div className="white-bg">
        <ToastContainer position={toast.POSITION.TOP_RIGHT} />
        <PageHeader
          pageTitle="Petrol Request"
          title="Allowance"
          setupForm={this.handleClickAddNew}
          isAddNew={this.state.isAddNew || this.state.isClaimAddNew}
          isView={this.state.isView}
          isEdit={this.state.isEdit}
        />
        {this.state.isAddNew && (
          <PetrolForm
            goBack={this.goBack}
            amountPerKmCar={this.state.amountPerKmCar}
            amountPerKmBike={this.state.amountPerKmBike}
            petrolVehicleTypes={this.state.petrolVehicleTypes}
            withdrawalLocations={this.state.withdrawalLocations}
            petrolTripTypes={this.state.petrolTripTypes}
            showError={this.showError}
          />
        )}
        {this.state.isEdit && (
          <PetrolForm
            goBack={this.goBack}
            amountPerKmCar={this.state.amountPerKmCar}
            amountPerKmBike={this.state.amountPerKmBike}
            petrolVehicleTypes={this.state.petrolVehicleTypes}
            withdrawalLocations={this.state.withdrawalLocations}
            petrolTripTypes={this.state.petrolTripTypes}
            petrolApplicationData={this.state.petrolApplicationData}
            showError={this.showError}
          />
        )}
        {this.state.isRequestsList && (
          <PetrolRequests
            petrolVehicleTypes={this.state.petrolVehicleTypes}
            withdrawalLocations={this.state.withdrawalLocations}
            employees={this.state.employees}
            regions={this.state.regions}
            departments={this.state.departments}
            positions={this.state.positions}
            showError={this.showError}
            onViewDetail={this.handleClickView}
            onEditDetail={this.handleClickEdit}
            permission={this.state.permission_status}
          />
        )}
        {this.state.isView && (
          <PetrolView
            petrolApplicationData={this.state.petrolApplicationData}
            showError={this.showError}
          />
        )}
      </div>
    );
  }
}
